var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcViewArrowLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87521 16.1967C6.54977 16.5221 6.54977 17.0498 6.87521 17.3752C7.20065 17.7006 7.72828 17.7006 8.05372 17.3752L14.8807 10.5482L14.8807 15.6074C14.8807 16.0677 15.2538 16.4408 15.714 16.4408C16.1743 16.4408 16.5474 16.0677 16.5474 15.6074L16.5474 8.53638C16.5474 8.31536 16.4596 8.1034 16.3033 7.94712C16.147 7.79084 15.9351 7.70304 15.714 7.70304L8.64298 7.70304C8.18274 7.70304 7.80964 8.07614 7.80964 8.53638C7.80964 8.99661 8.18274 9.36971 8.64298 9.36971L13.7022 9.36971L6.87521 16.1967Z",
    fill: "#0d1a16"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcViewArrowLight);
export default __webpack_public_path__ + "static/media/ic-view-arrowLight.102dcb02541350565fc50733bfb8db6a.svg";
export { ForwardRef as ReactComponent };